<template>
  <nav class="max-w-[960px] mx-auto px-5 my-10 md:my-12" v-if="categories.length > 0">
    <h2 class="mb-2">Filter posts by Category</h2>
    <p v-if="loading_categories">...</p>
    <p v-else-if="error">{{ error }}</p>

    <TabGroup v-else-if="categories.length > 0" @change="changedTab" manual>
      <TabList class="flex flex-wrap gap-2 p-1">
        <Tab v-slot="{ selected }" as="template"
          ><button
            class="
              block
              text-center text-sm
              md:text-xl
              font-title font-normal
              py-2 px-4
              rounded-full
            "
            :class="getTabClass('any', selected)"
          >
            Any
          </button>
        </Tab>
        <Tab
          v-for="i in categories.length"
          :key="categories[i - 1].slug"
          v-slot="{ selected }"
          as="template"
        >
          <button
            class="
              block
              text-center text-sm
              md:text-xl
              font-title font-normal
              py-2 px-4
              rounded-full
            "
            :class="getTabClass(categories[i - 1].slug, selected)"
          >
            {{ categories[i - 1].name }}
          </button>
        </Tab>
      </TabList>
    </TabGroup>
  </nav>
</template>
<script>
import { TabGroup, TabList, Tab } from '@headlessui/vue';
import HasColors from '../../../mixins/HasColors';

export default {
  name: 'blog-category-list',

  mixins: [HasColors],

  components: {
    TabGroup,
    TabList,
    Tab,
  },

  props: {
    categoryUrl: {
      type: String,
      default: '/json/categories',
    },
    currentCategory: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      categories: [],
      error: null,
      loading_categories: false,
    };
  },

  created() {
    this.getCategories();
  },

  methods: {
    getCategories() {
      this.loading_categories = true;
      this.error = null;

      fetch(this.categoryUrl)
        .then((response) => response.json())
        .then((response) => {
          this.categories = response.data;
        })
        .catch(() => {
          this.error = 'Error getting categories.';
        })
        .then(() => {
          this.loading_categories = false;
        });
    },

    changedTab(index) {
      if (index === 0) {
        this.$emit('select', null);
      } else {
        this.$emit('select', this.categories[index - 1].slug);
      }
    },

    getTabClass(slug, selected) {
      if (!selected) {
        return ['bg-gray-200', 'text-gray-800'];
      }

      return ['bg-' + this.bgColorFromSlug(slug), 'text-' + this.textColorFromSlug(slug)];
    },
  },
};
</script>
